import { Skeleton } from '@mui/material'
import { DOWNLOAD_API } from 'api/download-api'
import {
  AmountSunburstWithTable,
  AmountSunburstWithTableLoading,
  Card,
  DownloadLink,
  onDownloadLinkClick
} from 'components/core-v2'
import { useUser } from 'utilities/hooks/useUser'
import { plural } from 'utilities/plural'

import { getUserDisplayInfo } from '../../../tradebuilder-v2/util/user'
import { useFilteredGetByTenantAccountDashboardQuery } from '../../utils/useFilteredNotes'
import { getFeeTypeName } from '../trade-fees-breakdown-tab/utils'

export const FeeSunburstChart = () => {
  const { data, isFetching, isLoading } = useFilteredGetByTenantAccountDashboardQuery()
  const { data: user } = useUser()
  const { userType } = getUserDisplayInfo(user)

  if (isLoading || isFetching) {
    return (
      <Card.Wrapper>
        <Card.Header>
          <Skeleton height="15px" variant="rectangular" width="160px" />
        </Card.Header>
        <AmountSunburstWithTableLoading />
      </Card.Wrapper>
    )
  }

  const { fees } = data
  const title = `${fees.length} ${plural('Fee', fees.length)}`

  const chartData = fees.map(fee => ({
    parent: '0',
    id: fee.feeType,
    name: getFeeTypeName(fee.feeType),
    value: fee.zarValue
  }))

  const onDownloadClick = () => {
    onDownloadLinkClick({
      url: DOWNLOAD_API.exportPendingFees
    })
  }

  return (
    <Card.Wrapper>
      <Card.Header alignChildrenRight title={title}>
        {userType !== 'business-unit' && userType !== 'client' && (
          <DownloadLink onClick={onDownloadClick}>Export upcoming fees</DownloadLink>
        )}
      </Card.Header>
      <AmountSunburstWithTable data={chartData} nameHeading="Fee type" seriesName="Fees" />
    </Card.Wrapper>
  )
}
